// import type { TableConfig } from 'core/table';
import * as t from './actionTypes';

export const fetchCatalogs = () => ({ type: t.FETCH_CATALOGS_REQUEST });

export const fetchCatalogsResponse = (
  dataList /*: Array<*> */,
  dataObj /*: Object */,
  pending /*: Object */,
) => ({
  type: t.FETCH_CATALOGS_RESPONSE,
  dataList,
  dataObj,
  pending,
});

export const fetchCatalogsError = () => ({ type: t.FETCH_CATALOGS_ERROR });

export const fetchPaginatedCatalogItems = (
  tableName /*: string */,
  filters /*: TableConfig */,
) => ({
  type: t.FETCH_PAGINATED_CATALOG_ITEMS_REQUEST,
  tableName,
  filters,
});

export const fetchPaginatedCatalogItemsResponse = (
  dataList /*: Array<*> */,
  dataObj /*: Object */,
  tableName /*: string */,
  filters /*: TableConfig */,
  pending /*: Object */,
  total /*: number */,
  sizeInBytes /*: number */,
) => ({
  type: t.FETCH_PAGINATED_CATALOG_ITEMS_RESPONSE,
  dataList,
  dataObj,
  tableName,
  filters,
  pending,
  total,
  sizeInBytes,
});

export const fetchPaginatedCatalogItemsError = (error /*: string */) => ({
  type: t.FETCH_PAGINATED_CATALOG_ITEMS_ERROR,
  error,
});

export const removeCatalog = (tableName /*: string */) => ({
  type: t.REMOVE_CATALOG_REQUEST,
  tableName,
});

export const removeCatalogResponse = (
  dataList /*: Array<Object> */,
  dataObj /*: Object */,
  message /*: string */,
) => ({
  type: t.REMOVE_CATALOG_RESPONSE,
  dataList,
  dataObj,
  message,
});

export function removeCatalogError(error /*: string */) {
  return {
    type: t.REMOVE_CATALOG_ERROR,
    error,
  };
}

export const removeCatalogItem = (tableName /*: string */, tableKey /*: string */) => ({
  type: t.REMOVE_CATALOG_ITEM_REQUEST,
  tableName,
  tableKey,
});

export const removeCatalogItemResponse = (pendingDelete /*: Object */) => ({
  type: t.REMOVE_CATALOG_ITEM_RESPONSE,
  pendingDelete,
});

export const removeCatalogItemError = (error /*: string */) => ({
  type: t.REMOVE_CATALOG_ITEM_ERROR,
  error,
});

export const createNewCatalogRequest = (catalogName /*: string */) => ({
  type: t.CREATE_CATALOG_REQUEST,
  catalogName,
});

export const createNewCatalogResponse = (pending /*: Object */, catalogName /*: string */) => ({
  type: t.CREATE_CATALOG_RESPONSE,
  pending,
  catalogName,
});

export const createNewCatalogError = (error) => ({
  type: t.CREATE_CATALOG_ERROR,
  error,
});

export const fetchCatalogNames = () => ({ type: t.FETCH_CATALOG_NAMES_REQUEST });

export const fetchCatalogNamesResponse = (dataObj /*: Object */) => ({
  type: t.FETCH_CATALOG_NAMES_RESPONSE,
  dataObj,
});

export const fetchCatalogNamesError = (error /*: string */) => ({
  type: t.FETCH_CATALOG_NAMES_ERROR,
  error,
});

export const updateCatalogDisplaySetting = (isDisplayTable /*: boolean */) => ({
  type: t.UPDATE_CATALOG_DISPLAY_SETTING,
  isDisplayTable,
});

export const openCustomizeColumnsModal = () => ({ type: t.OPEN_CUSTOMIZE_TABLE_COLUMNS_MODAL });

export const changeTableColumns = (
  enabledColumns /*: [] */,
  disabledColumns /*: [] */,
  reordered /*: boolean */,
) => ({
  type: t.CHANGE_TABLE_COLUMNS,
  enabledColumns,
  disabledColumns,
  reordered,
});

export const changeTablePageSize = (currentPageSize, newPageSize) => ({
  type: t.CHANGE_TABLE_PAGE_SIZE,
  currentPageSize,
  newPageSize,
});

export const filterTable = (filter /*: string */) => ({ type: t.FILTER_TABLE, filter });

export const refreshTable = () => ({ type: t.REFRESH_TABLE });
